export default __webpack_public_path__ + "media/zurb/img/events/speaking/speaking-logos-c5d428fa3b0aebfb38b069df717ef4fd.png";